import { useLoad } from '@gogame/query';

import { loadPartnerAudience } from 'scenes/CustomAudiences/PartnerAudiences/sources/partnerAudiences';

import { model } from './queryKeyFactory';

export const useLoadPartnerAudience = (params) => {
  return useLoad(model(params), () => loadPartnerAudience(params), {
    enabled: true,
  });
};
